import { areaService } from "@/api/area.service";
import { areaDataInRootState } from "@/helpers/store-helpers";
import router from '@/router/index';

export const state = {
  selectedAreaId: null
}

export const actions = {
  resetArea({ commit }, { callback }) {
    commit("setSelectedArea", null);
    if (callback) callback();
  },
  switchArea({ commit, rootState }, { id, callback }) {
    commit("setSelectedArea", id);
    const { property, area } = areaDataInRootState(rootState);
    commit(
      'navigation/breadcrumbAdded',
      {
        text: `${area.name}(${area.nickname})`,
        level: 2,
        areaId: id,
        to: `/properties/${property.id}/areas/${id}`,
        active: true
      },
      { root: true }
    );
    if (callback) callback();
  },
  uploadPhoto({ commit, dispatch, rootState }, { file, callback }) {
    const { property, area } = areaDataInRootState(rootState);
    areaService.uploadPhoto(property.id, area.id, file)
      .then(response => {
        commit(
          "property/setAreaPhotos",
          {
            propertyId: property.id,
            areaId: area.id,
            photos: response.photos
          },
          { root: true }
        );
        if (callback) callback();
        dispatch('property/cacheProperties', null, { root: true });
      });
  },
  deletePhoto({ commit, dispatch, rootState }, { id, callback }){
    const { property, area } = areaDataInRootState(rootState);
    areaService.deletePhoto(property.id, area.id, id)
      .then(response => {
        commit(
          "property/setAreaPhotos",
          {
            propertyId: property.id,
            areaId: area.id,
            photos: response.photos
          },
          { root: true }
        );
        if (callback) callback();
        dispatch('property/cacheProperties', null, { root: true });
      });
  },
  createArea({ commit, rootState, dispatch }, payload) {
    const { property } = areaDataInRootState(rootState);
    areaService.createArea(property.id, payload)
      .then(data => {
        commit("property/setArea", { propertyId: property.id, data }, { root: true });
        commit("menu/addMenuItem", { property, area: data }, { root: true });
        router.push({ name: 'Area', params: { propId: property.id, areaId: data.id, keepNotifications: true } });
        dispatch("notification/success", 'Area created.', { root: true });
        dispatch("property/cacheProperties", null, { root: true });
      });
  },
  updateArea({ commit, rootState, dispatch }, payload) {
    const { property, area } = areaDataInRootState(rootState);
    areaService.updateArea(property.id, area.id, payload)
      .then(data => {
        commit("property/setArea", { propertyId: property.id, areaId: area.id, data }, { root: true });
        commit("menu/updateMenuItemLabel", { label: data.name, propertyId: property.id, areaId: area.id }, { root: true })
        commit("navigation/updateBreadcrumbLabel", { label: `${data.name}(${data.nickname})`, areaId: area.id }, { root: true });
        dispatch("notification/success", 'Area updated.', { root: true });
        dispatch("property/cacheProperties", null, { root: true });
      });
  },
};

export const mutations = {
  setSelectedArea(state, areaId) {
    state.selectedAreaId = areaId;
  },
};

export const getters = {
  selectedArea(_state, _getters, rootState) {
    const { area } = areaDataInRootState(rootState);

    return area;
  },

  selectedPropertyAreas(_state, _getters, rootState) {
    const { property } = areaDataInRootState(rootState);
    const areas = property.areas;

    return areas;
  }
};
